import styled from 'styled-components';

export const Dialog = styled.div`
  position: fixed;
`;
